<template>
  <div class="h-27 px-5 xl:px-14 bg-white hidden lg:flex lg:justify-between lg:items-center transition-[padding] text-sm xl:text-base">
    <LangRouterLink :to="{name: $routes.HOME}" class="shrink-0">
      <ResponsiveImage :media="chair.logo" class="h-10 xl:h-12.5"/>
    </LangRouterLink>
    <div class="flex items-center">
      <div class="flex items-center gap-1 xl:gap-2 mr-3 xl:mr-12.5 transition-[gap_margin]">
        <NavigationSection v-for="(section, sectionIndex) in sections" :pages="pages" :section="section"
                           :key="`desktop-menu-section-${sectionIndex}`"/>
      </div>
      <LangRouterLink :to="{...$route, hash: '#contact'}" class="button">
        {{ $t('contact_us') }}
      </LangRouterLink>
      <template v-if="!chair?.disable_english_site">
        <div class="w-[1px] h-8 bg-line block mx-2 xl:mx-7.5"/>
        <LangSwitch/>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import type {PropType} from 'vue'
import {LangRouterLink, ResponsiveImage} from '@/components/helpers'
import {LangSwitch, NavigationSection} from '@/components/navigation/small'

export default {
  name: 'DesktopNavigation',
  components: {LangSwitch, LangRouterLink, NavigationSection, ResponsiveImage},
  props: {
    chair: {
      type: Object as PropType<Chair>,
      required: true
    },
    pages: {
      type: Object as PropType<Record<template, Page>>,
      required: true
    },
    sections: {
      type: Array as PropType<MenuSection[]>,
      required: true
    }
  }
}
</script>
